import ComputerIcon from "@mui/icons-material/Computer";
import TabletIcon from "@mui/icons-material/Tablet";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";

export default function PreviewDevicePicker({device, setDevice}) {
    // Used in preview Screens to handle device picking
    // logic

    // BUILD
    return (
        <div className={"w-full flex justify-between border-[1px] border-greyLight5 rounded-[8px] px-[12px] py-[8px] text-greyLight9"}>
            <ComputerIcon className={`cursor-pointer ${device === "desktop" ? "text-primaryDark1" : ""}`}
                          onClick={() => setDevice('desktop')} />
            <TabletIcon className={`cursor-pointer ${device === "tablet" ? "text-primaryDark1" : ""}`}
                        onClick={() => setDevice('tablet')} />
            <PhoneIphoneIcon className={`cursor-pointer ${device === "mobile" ? "text-primaryDark1" : ""}`}
                             onClick={() => setDevice('mobile')} />
        </div>
    )
}